import React, { useState, useEffect } from 'react';
import './Login.css';
import { useNavigate } from 'react-router-dom';
import flashMessage from '../components/HelperFunctions';
import { logEvent } from '../utils/logger';
import GoogleSignInButton from '../components/GoogleSignInButton';

function Login( {handleLogin} ) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordResetSuccess, setPasswordResetSuccess] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Send data to the server for email and password login
    const event = {
      event: {
        label: 'Click',
        data: {
          value: 'Login'
        }
      }

    }

    logEvent(event);

    const response = await fetch(`${process.env.REACT_APP_BACKEND_HOST}/login`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        password,
      }),
    });

    if (response.ok) {
      const data = await response.json()

      const token = data.token;

      // Set the JWT token in the browser's cookies and set the user in the app context, available to all pages
      handleLogin(token);

      
    } else {
      flashMessage('error', 'Invalid email or password');
      console.error('Login failed');
    }
  };

  useEffect(() => {

    // get the password-reset-success query param from the URL
    const urlParams = new URLSearchParams(window.location.search);
    const passwordResetSuccess = urlParams.get('password-reset-success');

    setPasswordResetSuccess(passwordResetSuccess);

    // Clear only the notice; preserve the call destination for both login methods.
    urlParams.delete('password-reset-success');
    const remainingSearch = urlParams.toString();
    window.history.replaceState({}, '', `${window.location.pathname}${remainingSearch ? `?${remainingSearch}` : ''}`);

    const event = {
      event: {
        label: 'PageView',
        data: {
          page: 'Login'
        }
      }

    }

    logEvent(event);

  }, []);

  return (
    <div>
       <div className='page-content auth-page'>
        <div className="auth-intro"><span>Sayable.ai</span><h1>Your front desk, always ready.</h1><p>Manage calls, receptionist workflows, and customer information from one focused workspace.</p><div className="auth-proof"><strong>24/7</strong><span>Professional call handling built around your business.</span></div></div>
        <div className="login-section auth-card">
          <div className="page-title">Welcome back</div>
          <p className="auth-card-subtitle">Sign in to manage your AI receptionist.</p>
          <GoogleSignInButton divider onSuccess={result => {
            if (result.token) handleLogin(result.token);
            else navigate(result.status === 'verify_email' ? '/verify-account' : '/pricing');
          }} />
          {passwordResetSuccess && (<div className="login-info">Your password has been reset. Sign in with your new password.</div>)}
          <form onSubmit={handleSubmit}>
            <label className="login-label" htmlFor="email">Email</label>
            <input
              type="text"
              name="email"
              id="email"
              onChange={(e) => setEmail(e.target.value)}
            />

            <label className="login-label" htmlFor="password">Password</label>
            <input
              type="password"
              name="password"
              id="password"
              onChange={(e) => setPassword(e.target.value)}
            />

            <button className="button login-button" type="submit">Sign in</button>
            <button type="button" className="forgot-password-link" onClick={() => navigate('/password-reset')}>Forgot password?</button>
          </form>

          {/* <div className="third-party-login-section">
            <GoogleLogin
              buttonText="Login with Google"
              onSuccess={handleGoogleSuccess}
              onFailure={handleGoogleFailure}
              cookiePolicy={'single_host_origin'}
            />
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default Login;
